import { render, staticRenderFns } from "./UserOrders.vue?vue&type=template&id=3ab33756&"
import script from "./UserOrders.vue?vue&type=script&lang=ts&"
export * from "./UserOrders.vue?vue&type=script&lang=ts&"
import style0 from "./UserOrders.vue?vue&type=style&index=0&id=3ab33756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports